function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if (summary.nextElementSibling.getAttribute('id')) {
        summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    if (summary.closest('header-drawer, menu-drawer')) return;
    summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
            event.preventDefault();
            first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();

    if (
        elementToFocus.tagName === 'INPUT' && ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
    ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
    }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
    document.querySelector(':focus-visible');
} catch (e) {
    focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
    const navKeys = [
        'ARROWUP',
        'ARROWDOWN',
        'ARROWLEFT',
        'ARROWRIGHT',
        'TAB',
        'ENTER',
        'SPACE',
        'ESCAPE',
        'HOME',
        'END',
        'PAGEUP',
        'PAGEDOWN',
    ];
    let currentFocusedElement = null;
    let mouseClick = null;

    window.addEventListener('keydown', (event) => {
        if (navKeys.includes(event.code.toUpperCase())) {
            mouseClick = false;
        }
    });

    window.addEventListener('mousedown', (event) => {
        mouseClick = true;
    });

    window.addEventListener(
        'focus',
        () => {
            if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

            if (mouseClick) return;

            currentFocusedElement = document.activeElement;
            currentFocusedElement.classList.add('focused');
        },
        true
    );
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
    });
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    const summaryElement = openDetailsElement.querySelector('summary');
    openDetailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.focus();
}

class QuantityInput extends HTMLElement {
    constructor() {
        super();

        // Handle both dropdowns and input fields
        this.select = this.querySelector('select');
        this.input = this.querySelector('input');

        if (this.select) {
            this.select.addEventListener('change', this.onSelectChange.bind(this));
        } else if (this.input) {
            this.input.addEventListener('change', this.onInputChange.bind(this));
            this.querySelectorAll('button').forEach((button) =>
                button.addEventListener('click', this.onButtonClick.bind(this))
            );
        }

        this.changeEvent = new Event('change', {
            bubbles: true
        });
    }

    quantityUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
    }

    disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
            this.quantityUpdateUnsubscriber();
        }
    }

    onSelectChange(event) {
        this.validateQtyRules();
    }

    onInputChange(event) {
        this.validateQtyRules();
    }

    onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        if (event.target.name === 'plus') {
            this.input.stepUp();
        } else if (event.target.name === 'minus') {
            this.input.stepDown();
        }

        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

        this.validateQtyRules();
    }

    validateQtyRules() {
        if (this.select) {
            // Dropdown-based quantity validation
            const value = parseInt(this.select.value);
            const min = parseInt(this.select.getAttribute('min')) || 1;
            const max = parseInt(this.select.getAttribute('max')) || 10;

            Array.from(this.select.options).forEach((option) => {
                const optionValue = parseInt(option.value);
                option.disabled = optionValue < min || optionValue > max;
            });

            this.toggleCaretIcons(value, min, max);
        } else if (this.input) {
            // Input field-based quantity validation
            const value = parseInt(this.input.value);
            const min = parseInt(this.input.getAttribute('min')) || 0;
            const max = parseInt(this.input.getAttribute('max')) || Infinity;

            const buttonMinus = this.querySelector(".quantity__button[name='minus']");
            const buttonPlus = this.querySelector(".quantity__button[name='plus']");

            if (buttonMinus) {
                buttonMinus.classList.toggle('disabled', value <= min);
            }
            if (buttonPlus) {
                // alert("hello duniya");
                $.ajax({
                    url: '/cart.js',
                    dataType: 'json',
                    success: function(cart) {
                        var sub = (cart.total_price / 100);

                        var subtotal = (cart.total_price / 100).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        });
                        var innersubtotal = subtotal.toLocaleString();
                        var incvat = $("#vat_per").val();
                        var final = ((sub * incvat) / 100).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        });
                        var sym = String($("#cur_sym").val());




                        $(".sub_t").text(sym + innersubtotal)
                        $(".vat_text").text(sym + final)

                    },
                    error: function() {
                        console.log('Error fetching cart data.');
                    }
                });

                buttonPlus.classList.toggle('disabled', value >= max);
            }
        }
    }

    toggleCaretIcons(value, min, max) {
        const caretUp = this.querySelector('.quantity__caret-up');
        const caretDown = this.querySelector('.quantity__caret-down');

        if (caretUp) {
            caretUp.classList.toggle('disabled', value >= max);
        }
        if (caretDown) {
            caretDown.classList.toggle('disabled', value <= min);
        }
    }
}

customElements.define('quantity-input', QuantityInput);


function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

function throttle(fn, delay) {
    let lastCall = 0;
    return function(...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
            return;
        }
        lastCall = now;
        return fn(...args);
    };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: `application/${type}`
        },
    };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    };
};

Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];
        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ?
        target.addEventListener(eventName, callback, false) :
        target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (var key in params) {
        var hiddenField = document.createElement('input');
        hiddenField.setAttribute('type', 'hidden');
        hiddenField.setAttribute('name', key);
        hiddenField.setAttribute('value', params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl = document.getElementById(country_domid);
    this.provinceEl = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');
        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function(e) {
        var opt = this.countryEl.options[this.countryEl.selectedIndex];
        var raw = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);
        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = '';
        }
    },

    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');
            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    },
};

class MenuDrawer extends HTMLElement {
    constructor() {
        super();

        this.mainDetailsToggle = this.querySelector('details');

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach((summary) =>
            summary.addEventListener('click', this.onSummaryClick.bind(this))
        );
        this.querySelectorAll(
            'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
        ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ?
            this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) :
            this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const parentMenuElement = detailsElement.closest('.has-submenu');
        const isOpen = detailsElement.hasAttribute('open');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        function addTrapFocus() {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
            summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
        }

        if (detailsElement === this.mainDetailsToggle) {
            if (isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

            if (window.matchMedia('(max-width: 990px)')) {
                document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
            }
        } else {
            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
                summaryElement.setAttribute('aria-expanded', true);
                parentMenuElement && parentMenuElement.classList.add('submenu-open');
                !reducedMotion || reducedMotion.matches ?
                    addTrapFocus() :
                    summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
            }, 100);
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event === undefined) return;

        this.mainDetailsToggle.classList.remove('menu-opening');
        this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
            details.removeAttribute('open');
            details.classList.remove('menu-opening');
        });
        this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
            submenu.classList.remove('submenu-open');
        });
        document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
        removeTrapFocus(elementToFocus);
        this.closeAnimation(this.mainDetailsToggle);

        if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
    }

    onFocusOut() {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
                this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        const parentMenuElement = detailsElement.closest('.submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        detailsElement.classList.remove('menu-opening');
        detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
        removeTrapFocus(detailsElement.querySelector('summary'));
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');
                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        };

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.querySelector('.section-header');
        this.borderOffset =
            this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty(
            '--header-bottom-position',
            `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
        );
        this.header.classList.add('menu-open');

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        window.addEventListener('resize', this.onResize);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }

    closeMenuDrawer(event, elementToFocus) {
        if (!elementToFocus) return;
        super.closeMenuDrawer(event, elementToFocus);
        this.header.classList.remove('menu-open');
        window.removeEventListener('resize', this.onResize);
    }

    onResize = () => {
        this.header &&
            document.documentElement.style.setProperty(
                '--header-bottom-position',
                `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
            );
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
    constructor() {
        super();
        this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
        this.addEventListener('keyup', (event) => {
            if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
        if (this.classList.contains('media-modal')) {
            this.addEventListener('pointerup', (event) => {
                if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
            });
        } else {
            this.addEventListener('click', (event) => {
                if (event.target === this) this.hide();
            });
        }
    }

    connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
    }

    show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();
    }

    hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        window.pauseAllMedia();
    }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
    constructor() {
        super();

        const button = this.querySelector('button');

        if (!button) return;
        button.addEventListener('click', () => {
            const modal = document.querySelector(this.getAttribute('data-modal'));
            if (modal) modal.show(button);
        });
    }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const poster = this.querySelector('[id^="Deferred-Poster-"]');
        if (!poster) return;
        poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent(focus = true) {
        window.pauseAllMedia();
        if (!this.getAttribute('loaded')) {
            const content = document.createElement('div');
            content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

            this.setAttribute('loaded', true);
            const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
            if (focus) deferredElement.focus();
            if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
                // force autoplay for safari
                deferredElement.play();
            }
        }
    }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Slider-"]');
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.enableSliderLooping = false;
        this.currentPageElement = this.querySelector('.slider-counter--current');
        this.pageTotalElement = this.querySelector('.slider-counter--total');
        this.prevButton = this.querySelector('button[name="previous"]');
        this.nextButton = this.querySelector('button[name="next"]');

        if (!this.slider || !this.nextButton) return;

        this.initPages();
        const resizeObserver = new ResizeObserver((entries) => this.initPages());
        resizeObserver.observe(this.slider);

        this.slider.addEventListener('scroll', this.update.bind(this));
        this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
        this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    }

    initPages() {
        this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
        if (this.sliderItemsToShow.length < 2) return;
        this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
        this.slidesPerPage = Math.floor(
            (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
        );
        this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
        this.update();
    }

    resetPages() {
        this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
        this.initPages();
    }

    update() {
        // Temporarily prevents unneeded updates resulting from variant changes
        // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
        if (!this.slider || !this.nextButton) return;

        const previousPage = this.currentPage;
        this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

        if (this.currentPageElement && this.pageTotalElement) {
            this.currentPageElement.textContent = this.currentPage;
            this.pageTotalElement.textContent = this.totalPages;
        }

        if (this.currentPage != previousPage) {
            this.dispatchEvent(
                new CustomEvent('slideChanged', {
                    detail: {
                        currentPage: this.currentPage,
                        currentElement: this.sliderItemsToShow[this.currentPage - 1],
                    },
                })
            );
        }

        if (this.enableSliderLooping) return;

        if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
            this.prevButton.setAttribute('disabled', 'disabled');
        } else {
            this.prevButton.removeAttribute('disabled');
        }

        if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
            this.nextButton.setAttribute('disabled', 'disabled');
        } else {
            this.nextButton.removeAttribute('disabled');
        }
    }

    isSlideVisible(element, offset = 0) {
        const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
        return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }

    onButtonClick(event) {
        event.preventDefault();
        const step = event.currentTarget.dataset.step || 1;
        this.slideScrollPosition =
            event.currentTarget.name === 'next' ?
            this.slider.scrollLeft + step * this.sliderItemOffset :
            this.slider.scrollLeft - step * this.sliderItemOffset;
        this.setSlidePosition(this.slideScrollPosition);
    }

    setSlidePosition(position) {
        this.slider.scrollTo({
            left: position,
        });
    }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
    constructor() {
        super();
        this.sliderControlWrapper = this.querySelector('.slider-buttons');
        this.enableSliderLooping = true;

        if (!this.sliderControlWrapper) return;

        this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
        if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

        this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
        // Value below should match --duration-announcement-bar CSS value
        this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

        this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
        this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
        this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
        this.setSlideVisibility();

        if (this.announcementBarSlider) {
            this.announcementBarArrowButtonWasClicked = false;

            this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
            this.reducedMotion.addEventListener('change', () => {
                if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
            });

            [this.prevButton, this.nextButton].forEach((button) => {
                button.addEventListener(
                    'click',
                    () => {
                        this.announcementBarArrowButtonWasClicked = true;
                    }, {
                        once: true
                    }
                );
            });
        }

        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    }

    setAutoPlay() {
        this.autoplaySpeed = this.slider.dataset.speed * 1000;
        this.addEventListener('mouseover', this.focusInHandling.bind(this));
        this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
        this.addEventListener('focusin', this.focusInHandling.bind(this));
        this.addEventListener('focusout', this.focusOutHandling.bind(this));

        if (this.querySelector('.slideshow__autoplay')) {
            this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
            this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
            this.autoplayButtonIsSetToPlay = true;
            this.play();
        } else {
            this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
        }
    }

    onButtonClick(event) {
        super.onButtonClick(event);
        this.wasClicked = true;

        const isFirstSlide = this.currentPage === 1;
        const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

        if (!isFirstSlide && !isLastSlide) {
            this.applyAnimationToAnnouncementBar(event.currentTarget.name);
            return;
        }

        if (isFirstSlide && event.currentTarget.name === 'previous') {
            this.slideScrollPosition =
                this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
        } else if (isLastSlide && event.currentTarget.name === 'next') {
            this.slideScrollPosition = 0;
        }

        this.setSlidePosition(this.slideScrollPosition);

        this.applyAnimationToAnnouncementBar(event.currentTarget.name);
    }

    setSlidePosition(position) {
        if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
        this.setPositionTimeout = setTimeout(() => {
            this.slider.scrollTo({
                left: position,
            });
        }, this.announcerBarAnimationDelay);
    }

    update() {
        super.update();
        this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
        this.prevButton.removeAttribute('disabled');

        if (!this.sliderControlButtons.length) return;

        this.sliderControlButtons.forEach((link) => {
            link.classList.remove('slider-counter__link--active');
            link.removeAttribute('aria-current');
        });
        this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
        this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
    }

    autoPlayToggle() {
        this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
        this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
        this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
    }

    focusOutHandling(event) {
        if (this.sliderAutoplayButton) {
            const focusedOnAutoplayButton =
                event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
            if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
            this.play();
        } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
            this.play();
        }
    }

    focusInHandling(event) {
        if (this.sliderAutoplayButton) {
            const focusedOnAutoplayButton =
                event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
            if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
                this.play();
            } else if (this.autoplayButtonIsSetToPlay) {
                this.pause();
            }
        } else if (this.announcementBarSlider.contains(event.target)) {
            this.pause();
        }
    }

    play() {
        this.slider.setAttribute('aria-live', 'off');
        clearInterval(this.autoplay);
        this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
    }

    pause() {
        this.slider.setAttribute('aria-live', 'polite');
        clearInterval(this.autoplay);
    }

    togglePlayButtonState(pauseAutoplay) {
        if (pauseAutoplay) {
            this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
        } else {
            this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
            this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
        }
    }

    autoRotateSlides() {
        const slideScrollPosition =
            this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

        this.setSlidePosition(slideScrollPosition);
        this.applyAnimationToAnnouncementBar();
    }

    setSlideVisibility(event) {
        this.sliderItemsToShow.forEach((item, index) => {
            const linkElements = item.querySelectorAll('a');
            if (index === this.currentPage - 1) {
                if (linkElements.length)
                    linkElements.forEach((button) => {
                        button.removeAttribute('tabindex');
                    });
                item.setAttribute('aria-hidden', 'false');
                item.removeAttribute('tabindex');
            } else {
                if (linkElements.length)
                    linkElements.forEach((button) => {
                        button.setAttribute('tabindex', '-1');
                    });
                item.setAttribute('aria-hidden', 'true');
                item.setAttribute('tabindex', '-1');
            }
        });
        this.wasClicked = false;
    }

    applyAnimationToAnnouncementBar(button = 'next') {
        if (!this.announcementBarSlider) return;

        const itemsCount = this.sliderItems.length;
        const increment = button === 'next' ? 1 : -1;

        const currentIndex = this.currentPage - 1;
        let nextIndex = (currentIndex + increment) % itemsCount;
        nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

        const nextSlide = this.sliderItems[nextIndex];
        const currentSlide = this.sliderItems[currentIndex];

        const animationClassIn = 'announcement-bar-slider--fade-in';
        const animationClassOut = 'announcement-bar-slider--fade-out';

        const isFirstSlide = currentIndex === 0;
        const isLastSlide = currentIndex === itemsCount - 1;

        const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
        const direction = shouldMoveNext ? 'next' : 'previous';

        currentSlide.classList.add(`${animationClassOut}-${direction}`);
        nextSlide.classList.add(`${animationClassIn}-${direction}`);

        setTimeout(() => {
            currentSlide.classList.remove(`${animationClassOut}-${direction}`);
            nextSlide.classList.remove(`${animationClassIn}-${direction}`);
        }, this.announcerBarAnimationDelay * 2);
    }

    linkToSlide(event) {
        event.preventDefault();
        const slideScrollPosition =
            this.slider.scrollLeft +
            this.sliderFirstItemNode.clientWidth *
            (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
        this.slider.scrollTo({
            left: slideScrollPosition,
        });
    }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);
    }

    onVariantChange(event) {
        this.updateOptions();
        this.updateMasterId();
        this.updateSelectedSwatchValue(event);
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();

        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateURL();
            this.updateVariantInput();
            this.renderProductInfo();
            this.updateShareUrl();
        }
    }

    updateOptions() {
        this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
            if (element.tagName === 'SELECT') {
                return element.value;
            }
            if (element.tagName === 'FIELDSET') {
                return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
            }
        });
    }

    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options
                .map((option, index) => {
                    return this.options[index] === option;
                })
                .includes(false);
        });
    }

    updateSelectedSwatchValue({
        target
    }) {
        const {
            name,
            value,
            tagName
        } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
            const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
            const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
            if (!selectedDropdownSwatchValue) return;
            if (swatchValue) {
                selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
                selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
            } else {
                selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
                selectedDropdownSwatchValue.classList.add('swatch--unavailable');
            }

            selectedDropdownSwatchValue.style.setProperty(
                '--swatch-focal-point',
                target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
            );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
            const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
            if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
    }

    updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
        const productForms = document.querySelectorAll(
            `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        );
        productForms.forEach((productForm) => {
            const input = productForm.querySelector('input[name="id"]');
            input.value = this.currentVariant.id;
            input.dispatchEvent(new Event('change', {
                bubbles: true
            }));
        });
    }

    updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(
            (variant) => this.querySelector(':checked').value === variant.option1
        );
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;
            const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
            const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            const availableOptionInputsValue = selectedOptionOneVariants
                .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
                .map((variantOption) => variantOption[`option${index + 1}`]);
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
    }

    setInputAvailability(elementList, availableValuesList) {
        elementList.forEach((element) => {
            const value = element.getAttribute('value');
            const availableElement = availableValuesList.includes(value);

            if (element.tagName === 'INPUT') {
                element.classList.toggle('disabled', !availableElement);
            } else if (element.tagName === 'OPTION') {
                element.innerText = availableElement ?
                    value :
                    window.variantStrings.unavailable_with_option.replace('[value]', value);
            }
        });
    }

    updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
            pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
            pickUpAvailability.removeAttribute('available');
            pickUpAvailability.innerHTML = '';
        }
    }

    removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }

    updateMedia(html) {
        const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
        const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);

        const refreshSourceData = () => {
            const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
            const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
            const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, {
                item,
                index
            }]));
            return [mediaGallerySourceItems, sourceSet, sourceMap];
        };

        if (mediaGallerySource && mediaGalleryDestination) {
            let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
            const destinationSet = new Set(mediaGalleryDestinationItems.map(({
                dataset
            }) => dataset.mediaId));
            let shouldRefresh = false;

            // add items from new data not present in DOM
            for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
                if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
                    mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
                    shouldRefresh = true;
                }
            }

            // remove items from DOM not present in new data
            for (let i = 0; i < mediaGallerySourceItems.length; i++) {
                if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
                    mediaGallerySourceItems[i].remove();
                    shouldRefresh = true;
                }
            }

            // refresh
            if (shouldRefresh)[mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

            // if media galleries don't match, sort to match new data order
            mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
                const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

                if (sourceData && sourceData.index !== destinationIndex) {
                    mediaGallerySource.insertBefore(
                        sourceData.item,
                        mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
                    );

                    // refresh source now that it has been modified
                    [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
                }
            });
        }

        if (this.currentVariant.featured_media) {
            document
                .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
                ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
        }

        // update media modal
        const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
    }

    renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

        fetch(
                `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
            )
            .then((response) => response.text())
            .then((responseText) => {
                // prevent unnecessary ui changes from abandoned selections
                if (this.currentVariant.id !== requestedVariantId) return;

                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const destination = document.getElementById(`price-${this.dataset.section}`);
                const source = html.getElementById(
                    `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );
                const skuSource = html.getElementById(
                    `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );
                const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
                const inventorySource = html.getElementById(
                    `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );
                const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

                const volumePricingSource = html.getElementById(
                    `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );

                this.updateMedia(html);

                const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
                const pricePerItemSource = html.getElementById(
                    `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
                );

                const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
                const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
                const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

                if (volumeNote) volumeNote.classList.remove('hidden');
                if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
                if (qtyRules) qtyRules.classList.remove('hidden');

                if (source && destination) destination.innerHTML = source.innerHTML;
                if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
                if (skuSource && skuDestination) {
                    skuDestination.innerHTML = skuSource.innerHTML;
                    skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
                }

                if (volumePricingSource && volumePricingDestination) {
                    volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
                }

                if (pricePerItemSource && pricePerItemDestination) {
                    pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
                    pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
                }

                const price = document.getElementById(`price-${this.dataset.section}`);

                if (price) price.classList.remove('hidden');

                if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

                const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
                this.toggleAddButton(
                    addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
                    window.variantStrings.soldOut
                );

                publish(PUB_SUB_EVENTS.variantChange, {
                    data: {
                        sectionId,
                        html,
                        variant: this.currentVariant,
                    },
                });
            });
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
            if (text) addButtonText.textContent = text;
        } else {
            addButton.removeAttribute('disabled');
            addButtonText.textContent = window.variantStrings.addToCart;
        }

        if (!modifyClass) return;
    }

    setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);
        const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
        const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = window.variantStrings.unavailable;
        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
        if (pricePerItem) pricePerItem.classList.add('hidden');
        if (volumeNote) volumeNote.classList.add('hidden');
        if (volumeTable) volumeTable.classList.add('hidden');
        if (qtyRules) qtyRules.classList.add('hidden');
    }

    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then((response) => response.text())
                .then((text) => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');

                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                    }

                    if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
                        this.remove();
                    }

                    if (html.querySelector('.grid__item')) {
                        this.classList.add('product-recommendations--loaded');
                    }


                    var flkty = new Flickity('.related-products-items', {
                        freeScroll: true,
                        cellAlign: 'left',
                        pageDots: false,
                        contain: true,
                        autoplay: false,
                    });
                    const accessoryProducts = document.querySelector(".related-products-items");
                    if (accessoryProducts) {
                        accessoryProducts.addEventListener('wheel', function(e) {
                            flickity_handle_wheel_event(e, flkty);
                        });
                    }

                    jdgm.customizeBadges();

                })
                .catch((e) => {
                    console.error(e);
                });
        };

        new IntersectionObserver(handleIntersection.bind(this), {
            rootMargin: '0px 0px 400px 0px'
        }).observe(this);
    }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
    constructor() {
        super();

        this.icon = this.querySelector('.icon');
    }

    connectedCallback() {
        document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
    }

    handleStorefrontSignInCompleted(event) {
        if (event?.detail?.avatar) {
            this.icon?.replaceWith(event.detail.avatar.cloneNode());
        }
    }
}

$(document).ready(function() {
    $("#filter_btn").on("click", function() {
        $("#myPopup").addClass("show");
        $("body").addClass("body-filter");
    });

    $("#closePopup").on("click", function() {
        $("#myPopup").removeClass("show");
        $("body").removeClass("body-filter");
    });

    $(window).on("click", function(event) {
        if (event.target == $("#myPopup")[0]) {
            $("#myPopup").removeClass("show");
            $("body").removeClass("body-filter");
        }
    });
});

$(document).ready(function() {
    function checkScreenSize() {
        if ($(window).width() >= 1025) {
            $("#myPopup").html(" ");
        }
    }

    // Initial check
    checkScreenSize();

    // Check when the window is resized
    $(window).resize(function() {
        checkScreenSize();
    });
});

$(document).ready(function() {
    $(".info-popup-trigger").on("click", function() {
        $("body").addClass("popup-metamodal");
    });

    $("a.button.close").on("click", function() {
        $("body").removeClass("popup-metamodal");
    });

    $(".custom-sort .facet-filters .select").on("click", function() {
        $("body").removeClass("select-show").toggleClass("select-sort-by");
    });

    $(".custom-sort .products-per-page .select").on("click", function() {
        $("body").removeClass("select-sort-by").toggleClass("select-show");
    });

    $(".shortby_mobile").on("click", function() {
        // if($("span.select2-dropdown.select2-dropdown--below").hasClass('sort-select-mobile')){
        $("span.select2-dropdown.select2-dropdown--below").addClass('sort-select-mobile');
    });
});

$(document).ready(function() {
    // Event delegation to handle dynamically added elements
    $(document).on('click', '.rps-filter-checkbox', function() {
        // Toggle the active class on the clicked checkbox
        $(this).toggleClass('active');
    });

    // Handle the "Clear all filters" button click
    $(document).on('click', '.rps-reset-button.rps-vertical-selected-filters-clear', function() {
        // Remove the 'active' class from all checkboxes
        $('.rps-filter-checkbox').removeClass('active');
    });
});


$(document).ready(function() {
    // Event delegation to handle dynamically added elements
    $(document).on('click', '.rps-sort-option', function() {
        // Check if the clicked option is already active
        if ($(this).hasClass('active')) {
            // If it is already active, remove the active class
            $(this).removeClass('active');
        } else {
            // Otherwise, remove the active class from all options
            $('.rps-sort-option').removeClass('active');
            // Add the active class to the clicked option
            $(this).addClass('active');
        }
    });
});


// Flickity Slider code
function flickity_handle_wheel_event(e, flickity_instance) {
    // Check if the event is intended for horizontal scrolling
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();
        flickity_instance.applyForce(-e.deltaX / 50); // Invert the scroll direction
        flickity_instance.startAnimation();
        flickity_instance.dragEnd();
    }
}

const flickityOptions = {
    freeScroll: true,
    cellAlign: 'left',
    pageDots: false,
    contain: true,
    autoplay: false
};

function initializeFlickityWithWheel(selector, wheelEventHandler) {
    var flkty = new Flickity(selector, flickityOptions);
    const carouselElement = document.querySelector(selector);
    if (carouselElement) {
        carouselElement.addEventListener('wheel', function(e) {
            if (wheelEventHandler && typeof wheelEventHandler === 'function') {
                wheelEventHandler(e, flkty); // Call the custom wheel event handler
            }
        });
    }
    return flkty;
}

$(document).ready(function() {
    $(".dlvry.in-stock").on("click", function() {
        $("body").addClass("delivery-popup-open");
    });

    $("a.closebtn").on("click", function() {
        $("body").removeClass("delivery-popup-open");
    });

    if ($('.qty-instock').length) {
        $(".select2").on("click", function() {
            $("body").toggleClass("select-qty");
        });
    }
    $(".accessories-title .acc-select .select").on("click", function() {
        $("body").toggleClass("select-accessory");
    });

});

$(document).ready(function() {
    // Check if both elements exist
    if ($('.sign-up-text').length && $('.bitlogin-root').length) {
        // Append .sign-up-text after .bitlogin-root
        $('.sign-up-text').appendTo($('.bitlogin-root').parent());
    }
});

$(document).ready(function() {
    $(".mobile-tabs-dropdown").on("click", function() {
        $("body").addClass("select-blog");
    });
});

setTimeout(function() {
    var getappcode = jQuery(".gpo-container").length
    if (getappcode > 0) {
        $(".add-to-cart").hide();
        $(".configure-option").show();
    } else {
        $(".add-to-cart").show();
        $(".configure-option").hide();
    }
}, 1000);


$(document).ready(function() {
    if (!$('.pagination-wrapper').is(':visible')) {
        $('.custom-container.facets-vertical.page-width').addClass('no-pagination');
    }
});

$(document).mousemove(function(event) {
    if (!$('.rps_left_column').length) {
        $('.rps_right_column').addClass('no-result');
    } else {
        $('.rps_right_column').addClass('no-result');
    }
});

function findShortCode() {
    $(document).ready(function() {
        $('body *').contents().filter(function() {
            return this.nodeType === 3 && !$(this).parent().is('script, style');
        }).each(function() {
            var textNode = $(this);
            var textContent = textNode.text();
            if (/\[\[\[.*?\]\]\]/.test(textContent)) {
                blockData.forEach(function(item) {
                    var blockId = item.block.id;
                    var regex = new RegExp('\\[\\[\\[' + blockId + '\\]\\]\\]', 'g');
                    var tooltipHtml = '';

                    if (item.block.tooltip) {
                        tooltipHtml = `
                            <span class="tooltip">
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="14" height="14" rx="7" fill="#2352A1"/>
                                    <path d="M6.96961 4.76C6.49961 4.76 6.18961 4.47 6.18961 4.03C6.18961 3.58 6.49961 3.3 6.96961 3.3C7.43961 3.3 7.74961 3.58 7.74961 4.03C7.74961 4.47 7.43961 4.76 6.96961 4.76ZM7.67961 5.5V9.79C7.67961 10.01 7.77961 10.11 7.94961 10.11H8.45961V10.55H5.59961V10.11H6.09961C6.27961 10.11 6.36961 10.01 6.36961 9.79V6.26C6.36961 6.04 6.27961 5.94 6.09961 5.94H5.59961V5.5H7.67961Z" fill="white"/>
                                </svg>
                                <span class="tooltiptext">${item.block.tooltip}</span>
                            </span>
                        `;
                    }

                    if (item.block.category_filter == "true") {
                        textContent = textContent.replace(regex, `
                            <a href="javascript:void(0);" onclick="popupFunction('${blockId}')" class="info-popup-trigger">
                                ${tooltipHtml}
                            </a>
                        `);
                    } else {
                        textContent = textContent.replace(regex, `
                            <a href="javascript:void(0);" onclick="popupFunction('${blockId}')" class="info-popup-trigger">
                                ${item.block.short_title ? item.block.short_title : blockId}
                                ${tooltipHtml}
                            </a>
                        `);
                    }
                });
                textNode.replaceWith(textContent);
            }
        });
    });
};

$(document).ready(function() {
    setTimeout(function() {
        $('.rps-checked').each(function() {
            if ($(this).is(':empty')) {} else {
                $(this).parent().addClass("active");
            }
        });
    }, 1000);
});


function initializeCompareButtons() {
    var allHandles = dynamicCompareInstance.getHandles();

    function updateButtonStates() {
        $('.compare-btn').each(function(i, item) {
            var productHandle = $(item).attr('data-product-handle');
            var isProductInCompare = allHandles.includes(productHandle);

            if (isProductInCompare) {
                $(item).addClass('processing');
                updateIcons(item, true, false, false);

                setTimeout(function() {
                    $(item).removeClass('processing');
                    $(item).addClass('active');
                    $(item).find('span').text('Compared');
                    updateIcons(item, false, true, false);
                }, 1000);
            } else {
                updateIcons(item, false, false, true);
            }
        });
    }

    function handleButtonClick() {
        var self = this;
        var productHandle = $(this).attr('data-product-handle');
        var isProductInCompare = allHandles.includes(productHandle);

        if (isProductInCompare) {
            dynamicCompareInstance.removeProduct(productHandle);
            $(self).addClass('processing');
            $(self).removeClass('active');
            updateIcons(self, true, false, false);
            setTimeout(function() {
                $(self).removeClass('processing');
                $(self).find('span').text('Compare');
                updateIcons(self, false, false, true);
            }, 1000);
        } else {
            dynamicCompareInstance.addProduct(productHandle);
            $(self).addClass('processing');
            updateIcons(self, true, false, false);
            setTimeout(function() {
                $(self).removeClass('processing');
                $(self).addClass('active');
                $(self).find('span').text('Compared');
                updateIcons(self, false, true, false);
            }, 1000);
        }

        // Update the list of handles
        allHandles = dynamicCompareInstance.getHandles();
    }

    // Initial button state update
    updateButtonStates();

    // Bind click event to buttons
    $('.compare-btn').click(handleButtonClick);
}

// Initialize the compare buttons when the DOM is fully loaded
document.addEventListener('DOMContentLoaded', initializeCompareButtons);

$(document).ready(function() {
    var mainNavs = Array.from(document.querySelectorAll(".header-wrapper.header-wrapper--border-bottom"));
    var firstLevelNavItems = [];

    mainNavs.forEach(function(navElement) {
        var items = Array.from(navElement.querySelectorAll(".tmenu_item_level_0"));
        firstLevelNavItems = firstLevelNavItems.concat(items);
    });

    function moveUnderline(mainNav, item) {
        var firstLevelNavItemUnderline = mainNav.querySelector(".main-navigation-underline");

        if (firstLevelNavItemUnderline) {
            var itemRect = item.getBoundingClientRect();
            var itemLink = item.querySelector(".tmenu_item_link");

            if (itemLink) {
                var itemStyle = getComputedStyle(itemLink);
                firstLevelNavItemUnderline.style.left = (itemRect.left + parseFloat(itemStyle.paddingLeft)) + "px";
                firstLevelNavItemUnderline.style.width = (itemRect.width - parseFloat(itemStyle.paddingLeft) - parseFloat(itemStyle.paddingRight)) + "px";
            }
        }
    }

    function hideUnderline(mainNav) {
        var firstLevelNavItemUnderline = mainNav.querySelector(".main-navigation-underline");

        if (firstLevelNavItemUnderline) {
            // Reset underline to default position and width, ensure it's smooth by using CSS transitions
            firstLevelNavItemUnderline.style.left = "0"; // You can adjust this value to hide off-screen if necessary
            firstLevelNavItemUnderline.style.width = "100%"; // Collapse the underline smoothly
        }
    }

    firstLevelNavItems.forEach(function(firstLevelNavItem) {
        firstLevelNavItem.addEventListener("mouseenter", function() {
            var navElement = firstLevelNavItem.closest(".header-wrapper.header-wrapper--border-bottom");
            moveUnderline(navElement, firstLevelNavItem);
        });

        firstLevelNavItem.addEventListener("mouseleave", function() {
            var navElement = firstLevelNavItem.closest(".header-wrapper.header-wrapper--border-bottom");
            hideUnderline(navElement);
        });
    });

});


$(document).ready(function() {
    var intervalId,
        subIntervalId;
    intervalId = setInterval(function() {
        if ($(".tmenu_item_has_child > a .tmenu_indicator").length > 0) {
            $(".tmenu_item_has_child > a, .tmenu_item_has_child > a .tmenu_indicator").on("click", function() {
                $(this).closest('li').siblings().toggle();
                $($(this).closest('a').next('ul').find('.tmenu_indicator')).on("click", function() {
                    $(this).closest('.tmenu_item_level_0').toggleClass('active-sub');
                    $(this).closest('li').siblings().toggle();
                });
            });
            clearInterval(intervalId);
        }
    }, 1000);


    // var intervalIdEasy;
    // intervalIdEasy = setInterval(function() {
    //     if($(".easysearch-select-holder").length > 0) {
    //         $('.easysearch-select-holder select').select2();
    //         clearInterval(intervalIdEasy);
    //     }
    // }, 1000);



});

$(document).ready(function() {
    setTimeout(function() {
        $('.rps-product-final-price').each(function() {
            $(this).after('<p class="prod_excvat">Exc Vat</p>');
        });
    }, 1000); // 1000 milliseconds = 1 second delay
});

$(document).on('mousemove', function() {
    // Get the current URL
    var url = window.location.href;

    // Check if the URL contains the "page" parameter
    if (url.indexOf('page=') !== -1) {
        // Do something if the "page" parameter is present


        // Add the "Exc Vat" only if it doesn't already exist
        $('.rps-product-final-price').each(function() {
            if ($(this).next('.prod_excvat').length === 0) {
                $(this).after('<p class="prod_excvat">Exc Vat</p>');
            }
        });
    } else {
        // Do something if the "page" parameter is not present

    }
});
$(document).ready(function() {
    $(".search__input").keyup(function() {
        setTimeout(function() {
            // Insert the 'Exc Vat' paragraph after each matching element
            $('.rps_final_price').each(function() {
                if ($(this).next('.rps-prod_excvat').length === 0) {
                    $(this).after('<div class="rps-prod_excvat">Exc Vat</div>');
                }
            });
        }, 1000);
    });
});
$(".search__input").click(function() {
    setTimeout(function() {
        // Insert the 'Exc Vat' paragraph after each matching element
        $('.rps_final_price').each(function() {
            if ($(this).next('.rps-prod_excvat').length === 0) {
                $(this).after('<div class="rps-prod_excvat">Exc Vat</div>');
            }
        });
    }, 1000);
});

$(document).ready(function() {
    // Check if the element with class 'search-results-mobile' is present
    if ($(".search-results-mobile").length) {
        // Find the element with the 'rps_mov_clear_button' class
        var $clearButtonElement = $(".rps_mov_clear_button");

        if ($clearButtonElement.length) {
            // Define the new SVG code as a string
            var newSvg = `
        <svg class="rps_mov_search_button" viewBox="0 0 48 48" width="25" height="25">
          <circle cx="20.5" cy="20.5" r="12.5" fill="none" stroke="#797979" stroke-miterlimit="10" stroke-width="4"></circle>
          <line x1="29.339" x2="40" y1="29.339" y2="40" fill="none" stroke="#797979" stroke-linecap="round" stroke-miterlimit="10" stroke-width="4"></line>
        </svg>
      `;

            // Replace the old SVG with the new one
            $clearButtonElement.replaceWith(newSvg);
        }
    }
});

// Adding class when compatible-accessories section does not exist
$(document).ready(function() {
    if (!$('.compatible-accessories').length > 0) {
        $('.specifications-container').addClass('no-compatible-accessories');
    }
});

const dynamicCompareInstance = document.querySelector('sc-dynamic-compare');

function updateIcons(item, processingActive, activeActive, compareActive) {
    $(item).find('.processing-icon').toggleClass('active', processingActive);
    $(item).find('.active-icon').toggleClass('active', activeActive);
    $(item).find('.compare-icon').toggleClass('active', compareActive);
}


function findAndReloadDeliveryCoderScript() {
    var scripts = document.getElementsByTagName('script');
    var found = false;

    for (var i = 0; i < scripts.length; i++) {
        var script = scripts[i];
        if (script.src && script.src.includes('delivery_coder')) {
            found = true;
            reloadScript(script.src);
            break;
        }
    }
}

// Function to reload a script by its source URL
function reloadScript(scriptUrl) {
    var existingScript = document.querySelector(`script[src="${scriptUrl}"]`);
    if (existingScript) {
        existingScript.remove();
    }
    var script = document.createElement('script');
    script.src = scriptUrl;
    script.async = true;
    document.body.appendChild(script);
}

function outOfStockStatus() {
    const infoText = window.deliveryED.setting.delivery__app_setting.main_delivery_setting.out_of_stock_info;
    $('.outstock-product .msg__container').each(function() {
        $(this).html(infoText);
    });
}

function fetchAndDisplaySortedProducts(sortBy) {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sortBy);

    $.ajax({
        url: url.toString(),
        method: 'GET',
        success: function(response) {
            var newDocument = $(response);
            var newProductGrid = newDocument.find('#product-grid').html();
            $('#product-grid').html(newProductGrid);
            history.pushState(null, '', url.toString());
            findShortCode();
            findAndReloadDeliveryCoderScript();
            outOfStockStatus();
        },
        error: function() {
            console.error('Failed to fetch sorted products.');
        }
    });
}

function reapplyScript() {
    var scriptElements = document.querySelectorAll('script.jdgm-script');
    scriptElements.forEach(function(script) {
        var newScript = document.createElement('script');
        newScript.setAttribute('data-cfasync', 'false');
        newScript.className = 'jdgm-script';
        newScript.textContent = script.textContent;

        document.body.appendChild(newScript);
    });
}

$(document).ready(function() {
  setTimeout(function() {
    $(".dropdown-item input[type='radio']").on("change", function() {
        if ($(this).is(":checked")) {
          var selectedValue = $(this).val();
      setTimeout(function() {
        if($(".price--on-sale").length > 0)
        {
        var priceText = $(".price-item--last.custom").text();
        var price = priceText.match(/[\d,.]+/)[0];
        var per = $("input#inc-vat-pdp").val();
        var calc = (price * per ) / 100;
        var final_pri = Number(calc) + Number(price);
        var tofix = (final_pri).toFixed(2);
        var pricesym = $(".price-item--last.custom").text().trim();
        var currencySymbol = pricesym.match(/^[^\d]+/)[0].trim();
        $("span.price-item.price-item--sale.price-item--last.invat-custom-pdp").html(currencySymbol + tofix +"<span class='ex-vat'>Inc Vat</span>");
        $('.price-item--last.custom').append('<span class="ex-vat">Exc Vat </span>');
        }
        else
        {
        var priceText = $(".price-item--regular.custom").text();
        var price = priceText.match(/[\d,.]+/)[0];
        var per = $("input#inc-vat").val();
        var calc = (price * per ) / 100;
        var final_pri = Number(calc) + Number(price);
        var tofix = (final_pri).toFixed(2);
        var pricesym = $(".price-item--regular.custom").text().trim();
        var currencySymbol = pricesym.match(/^[^\d]+/)[0].trim();
        $("span.price-item.price-item--sale.price-item--last.invat-custom-pdp").html(currencySymbol + tofix +"<span class='ex-vat'>Inc Vat</span>");
        $('.price-item.price-item--regular.custom').append('<span class="ex-vat">Exc Vat </span>');
        }
     
       }, 1000);
      }
    });
  }, 1500);
});